import { render } from "./myCerts.vue?vue&type=template&id=3157dbc2&scoped=true"
import script from "./myCerts.vue?vue&type=script&lang=js"
export * from "./myCerts.vue?vue&type=script&lang=js"

import "./myCerts.vue?vue&type=style&index=0&id=3157dbc2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3157dbc2"]])

export default __exports__